export default {
  'projects.cohortBuilder.cohortCharacteristicsPageTab.title': 'Characteristics',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.description':
    'View demographic characteristics of the cohort.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.notProcessedHeader': 'No characteristics',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.notProcessedDescription':
    'Process the cohort to view characteristics data for subjects who meet all cohort criteria.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.drawerTitle': 'Demographics',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.drawerTitleType':
    '{type} characteristics',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.drawerTitle': 'Demographics',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.columnLabel': 'Characteristic',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.valueLabel': 'N =',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.ageAtIndexSection':
    'Age at index date, n (%)',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.genderSection': 'Gender, n (%)',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.raceSection': 'Race, n (%)',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.ethnicitySection':
    'Ethnicity, n (%)',

  'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.ccCondition': 'Condition, n (%)',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.ccDrug': 'Drug, n (%)',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.ccMeasurement': 'Measurement, n (%)',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.ccObservation': 'Observation, n (%)',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.ccProcedure': 'Procedure, n (%)',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.tabular.ccVisit': 'Visit, n (%)',

  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ageAtIndex': 'Age at index date',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.race': 'Race',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.gender': 'Gender',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ethnicity': 'Ethnicity',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.eventDistribution':
    '{chartTitleText} distribution over time',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.eventDistribution':
    'The current filter selection does not return any events.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.eventDistribution':
    'No event distribution data available',

  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccCondition': 'Top 10 conditions',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccDrug': 'Top 10 drugs',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccMeasurement':
    'Top 10 measurements',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccObservation':
    'Top 10 observations',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccProcedure': 'Top 10 procedures',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccVisit': 'Top 10 visits',

  // Custom titles for customized domains
  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccCondition.custom':
    'Selected customized conditions',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccDrug.custom':
    'Selected customized drugs',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccMeasurement.custom':
    'Selected customized measurements',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccObservation.custom':
    'Selected customized observations',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccProcedure.custom':
    'Selected customized procedures',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.section.ccVisit.custom':
    'Selected customized visits',

  // Custom concept selection
  'projects.cohortBuilder.cohortCharacteristics.customizeButton.label': 'Customize {domain}',
  'projects.cohortBuilder.cohortCharacteristics.customizeDialog.title': 'Customize {domain}',
  'projects.cohortBuilder.cohortCharacteristics.customizeDialog.description':
    'Select up to 10 items to display in the chart. At least one concept group must remain selected.',
  'projects.cohortBuilder.cohortCharacteristics.customizeDialog.selectionCount':
    '{selected} of {total} selected',
  'projects.cohortBuilder.cohortCharacteristics.customizeDialog.selectedGroups': 'Concept group',
  'projects.cohortBuilder.cohortCharacteristics.customizeDialog.selectGroups':
    'Select concept groups',
  'projects.cohortBuilder.cohortCharacteristics.customizeDialog.loading': 'Loading {domain}',
  'projects.cohortBuilder.cohortCharacteristics.customizeDialog.applySelection': 'Apply selection',
  'projects.cohortBuilder.cohortCharacteristics.domain.conditions': 'conditions',
  'projects.cohortBuilder.cohortCharacteristics.domain.drugs': 'drugs',
  'projects.cohortBuilder.cohortCharacteristics.domain.measurements': 'measurements',
  'projects.cohortBuilder.cohortCharacteristics.domain.observations': 'observations',
  'projects.cohortBuilder.cohortCharacteristics.domain.procedures': 'procedures',
  'projects.cohortBuilder.cohortCharacteristics.domain.visits': 'visits',

  // no results - sections
  'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ageAtIndex':
    'No age at index date',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.race': 'No race',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.gender': 'No gender',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ethnicity': 'No ethnicity',

  'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ccCondition': 'No condition',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ccDrug': 'No drug',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ccMeasurement': 'No measurement',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ccObservation': 'No observation',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ccProcedure': 'No procedure',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.title.empty.ccVisit': 'No visit',

  'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.ageAtIndex':
    'Set an index date and re-process the cohort to view data for age at index.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.race':
    'Update cohort and re-process the cohort to view data for race.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.gender':
    'Update cohort and re-process the cohort to view data for gender.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.ethnicity':
    'Update cohort and re-process the cohort to view data for ethnicity.',

  'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.ccCondition':
    'Update cohort and re-process the cohort to view data for condition.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.ccDrug':
    'Update cohort and re-process the cohort to view data for drug.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.ccMeasurement':
    'Update cohort and re-process the cohort to view data for measurement.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.ccObservation':
    'Update cohort and re-process the cohort to view data for observation.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.ccProcedure':
    'Update cohort and re-process the cohort to view data for procedure.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.message.empty.ccVisit':
    'Update cohort and re-process the cohort to view data for visit.',

  'projects.cohortBuilder.cohortCharacteristicsCharts.barChart.xAxisLabel': 'Age (years)',
  'projects.cohortBuilder.cohortCharacteristicsCharts.barChart.yAxisLabel': 'Count',
  'projects.cohortBuilder.cohortCharacteristicsCharts.barChart.seriesLabel': 'Age',
  'projects.cohortBuilder.cohortCharacteristicsCharts.eventDistributionOverTimeChart.xAxisLabel':
    'Year',
  'projects.cohortBuilder.cohortCharacteristicsCharts.eventDistributionOverTimeChart.yAxisLabel':
    'Number of events',
  'projects.cohortBuilder.cohortCharacteristicsCharts.personDistributionOverTimeChart.yAxisLabel':
    'Number of patients',
  // no data to display
  'projects.cohortBuilder.cohortCharacteristicsPageTab.noData.title': 'No characteristics',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.noData.message':
    'Process the cohort to view characteristics data for subjects who meet all cohort criteria.',

  // workflow message
  'projects.cohortBuilder.cohortCharacteristicsPageTab.draft.title': 'No characteristics',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.draft.message':
    'Process the cohort to view characteristics data for subjects who meet all cohort criteria.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.processing.title':
    'Processing characteristics',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.processing.message':
    'Characteristics data for subjects who meet all cohort criteria will be available once cohort processing is complete.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.error.title': 'No characteristics',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.error.message':
    'Edit and re-process the cohort to view characteristics data for subjects who meet all cohort criteria.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.processedNoData.title': 'No characteristics',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.processedNoData.message':
    'Edit and re-process the cohort to view characteristics data for subjects who meet all cohort criteria.',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.loading.title': 'Loading characteristics',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.loading.customSelection.title':
    'Loading custom selection',

  'projects.cohortBuilder.cohortCharacteristicsPageTab.dropdown.ccCondition': 'Condition',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.dropdown.ccDrug': 'Drug',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.dropdown.ccMeasurement': 'Measurement',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.dropdown.ccObservation': 'Observation',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.dropdown.ccProcedure': 'Procedure',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.dropdown.ccVisit': 'Visit',

  'projects.cohortBuilder.cohortCharacteristicsPageTab.dropdown.demographics': 'Demographics',
  'projects.cohortBuilder.cohortCharacteristicsPageTab.dropdown.clinical': 'Clinical',
};
